import React, { useState } from 'react';
import { ApButtonTab } from '@alixpartners/ui-components';
import APStats from './AlixPartnerStats/APStats';
import { ContentDiv, FlexWrapper } from './ApVendorLibrary.styles';
import SecondaryNav from './SecondaryNav/SecondaryNav';
import { VendorCountProvider } from 'contexts/APVendorLibraryContext/VendorCountProvider';
import { VendorSpendProvider } from 'contexts/APVendorLibraryContext/VendorSpendProvider';

import ExploreLibrary from './Explore Library/ExploreLibrary';
import { CategoryAndLevelProvider } from 'contexts/APVendorLibraryContext/VendorCategoryLevelProvider';

const INITIAL_SUBNAV_CONFIG = [
	{
		id: 1,
		name: 'alixparnters-stats',
		label: 'AlixPartners Stats',
		isActive: true,
		component: APStats,
	},
	{
		id: 2,
		name: 'explore-library',
		label: 'Explore Library',
		isActive: false,
		component: ExploreLibrary,
	},
];

const ApVendorLibrary = () => {
	const [subNav, setSubNav] = useState(INITIAL_SUBNAV_CONFIG);

	const subNavHandler = value => {
		setSubNav(prevState =>
			prevState.map(el => {
				if (el.id === value) {
					return { ...el, isActive: true };
				} else {
					return { ...el, isActive: false };
				}
			})
		);
	};
	return (
		<>
			<SecondaryNav />
			<FlexWrapper>
				<div>
					{subNav.map(({ id, name, label, isActive }) => (
						<ApButtonTab
							key={id}
							name={name}
							isSelected={isActive}
							onClick={() => subNavHandler(id)}
						>
							{label}
						</ApButtonTab>
					))}
				</div>
			</FlexWrapper>
			<CategoryAndLevelProvider>
				<VendorSpendProvider>
					<VendorCountProvider>
						<ContentDiv>
							{subNav.map(({ id, isActive, component: Component }) => {
								return isActive && <Component key={id} />;
							})}
						</ContentDiv>
					</VendorCountProvider>
				</VendorSpendProvider>
			</CategoryAndLevelProvider>
		</>
	);
};

export default ApVendorLibrary;
